/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch } from "react-redux";
import XLSX from "sheetjs-style";

import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import styles from "./SapDataTransfer.module.css";
import { CustomDatePicker, CustomFormGroup } from "../FormComponents";
import { DATE_FORMAT, MESSAGE_TYPE, RESOURCE_TYPE } from "../../constants";
import Table from "../Table/Table";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import {  Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import { getInvoice } from "../../redux/actions/productsActions";
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';

function ReportNoPO({ baseUrl, auth }) {
  const ROW_HEIGHT = 38;

  const { showPopup } = usePopupManager();
  const dispatchNew = useDispatch();
  const history = useHistory();

  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [allTableData,setAllTableData]=useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [tableFlag,setTableFlag]=useState(false);
  const [allData,setAllData]=useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [myState, setState] = React.useState({
    toDate: null,
    fromDate: null
  });

  const HEIGHT = '250px';
  const FILENAME = 'SAP_Data_Transfer_Report';

  const handleOpen = () =>{
    setIsPopupOpen(true)
    setTableData([])
    window.location.reload()
  } ;

  const setCount = (count) => {
    setAsnCount(count);
  };
  const handleDate = (date, name) => {
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;

    }
    let newDate = date.format(DATE_FORMAT.ISO)
    setState((prevData) => ({ ...prevData, [name]: date }));

  }

  useEffect(() => {
    setViewDisplay(true);
  }, []);

  const convert2 = (str) => {
    if (str == null) {
      return '';
    } else {


      const date = new Date(str);
      const mnth = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
      //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29 

      return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  }

  const handleSubmit = (dataflag) => {
    setLoading(true)
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);
    
    if (myState.fromDate == "" || myState.toDate == ""  || myState.fromDate==null ||myState.toDate==null) {
      setLoading(false)
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter a date"
      });
      return
    } 
    const isSameOrAfter = moment(fromDate).isAfter(toDate); 
    if (isSameOrAfter) {
       setLoading(false)
       setAllTableData([])
       setTableFlag(false);
       showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "End Date Should Be Greater Than  Or Equal To Start Date ",
      });
      }
    else {
   
    let finalfromdate=moment(fromDate, 'MM-DD-YYYY').format('DD-MM-YYYY');
    let finaltodate=moment(toDate, 'MM-DD-YYYY').format('DD-MM-YYYY');
      let apiFormatedData = {
        flag: dataflag,
        from_date: finalfromdate,
        to_date: finaltodate
      };
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}reports/SAPDataTransferReport`, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      })
        .then((response) => {
         
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoading(false);
          }
    
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson.msg=="Success" && responseJson.data.length != 0){
            setLoading(false);
            const finalList = [];
            responseJson.data.map((row, index) => {
              finalList.push({
                id: index,
                ...row,
              });
            });
            setAllData(finalList)
            setTableData(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
            setAllTableData(finalList)
            setTableFlag(true)
          }
          else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "No Records Found",
          })
          setAllData([])
          }
          else if(responseJson && responseJson.msg=="Fail")  {
            setLoading(false);
            setAllData([])
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: responseJson.data,
          })
          }  
        })
        .catch((error) => {
          setLoading(false)
          setAllData([])
          if (error.response) {
            showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "Oops! Something went wrong. Please try again later. Please try again later",
                })
          }
          else {
            showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: "There might be Network issue, please try after some time",
              })
          }
        });
    }
  };

  const baseDefaultColumns = [
    {
      width: 100,
      title: "Project Definition",
      field: "project_definition",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 160,
      title: "Project Description",
      field: "project_description",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 90,
      title: "BU",
      field: "bu",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "SUB Bu",
      field: "subbu",
      enableSearch: true,
      enableFilter: true
    },

    {
      width: 90,
      title: "Vehicle Type",
      field: "vehicle_type",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 90,
      title: "Vehicle Family ",
      field: "vehicle_family",
      enableSearch: true,
      enableFilter: true
    },

    {
      width: 100,
      title: "BC Number",
      field: "cost_center",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "BC Name",
      field: "bc_name",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Network",
      field: "network",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Gate (EVM Activity) Number",
      field: "gate_number",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Gate (EVM Activity) Description",
      field: "gate_description",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Status",
      field: "status",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Document Date",
      field: "docdate",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Month",
      field: "month",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 90,
      title: "Sent Hours",
      field: "sent_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Received Hours",
      field: "received_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 80,
      title: "Type",
      field: "type",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 80,
      title: "Location",
      field: "location",
      enableSearch: true,
      enableFilter: true
    }
  ];

  const renderOther = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      > 
        <Grid item md={3} lg={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => { handleDate(e, 'fromDate') }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        <Grid item md={3} lg={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>

              <CustomDatePicker

                clearable
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {
                  handleDate(e, 'toDate')
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),

                }}
                emptyLabel="DD-MM-YYYY"
              
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
             


              />
            </div>
          </div>
          {myState.handoverDateFlag &&
            <div style={{ marginLeft: "35px" }} className={styles.error}>Inserted On is mandatory field</div>

          }

        </Grid>
        <Grid item md={6} lg={6} >
        
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => handleSubmit("TOTAL_DATA")}
                data-testid="confirm-action"
              >
                View All
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => handleSubmit("SUCCESS_DATA")}
                data-testid="confirm-action"
              >
                SuccessFull Records
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => handleSubmit("FAILED_DATA")}
                data-testid="confirm-action"
              >
                Records Not Transfer
              </Button>

              <Button
          className={clsx(styles.actionButton, styles.resetButton)}
          variant="tertiary"
          onClick={handleOpen}
          style={{marginLeft: "10px"}}
        >
          CANCEL
        </Button>
            </div>
         
        </Grid>
      </Grid>
    </div>
  );

  function downloadExcel(data) {
    const columnsKeys = {
      AuthBC: "Authorized BC No",
      PersonName: "Person Name",
      Barrel: "Barrel",
      ProjectDef: "Project Def",
      Person: "Person No"
    };
    data.forEach((item, index) => {
      item.id = index + 1;
    });
    const updateExportData = data.map((dict) =>
      Object.keys(dict).reduce((acc, key) => {
        acc[columnsKeys[key] || key] = dict[key];
        return acc;
      }, {})
    );
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
    XLSX.writeFile(workbook, "Linkagedetails.xlsx");
  }

  // useEffect(()=>{
  //   if(rowsPerPage*page > allData.length){
  //     showPopup({
  //       type: MESSAGE_TYPE.INFORMATION,
  //       contextText: MESSAGE_TYPE.INFORMATION,
  //       info: "No data"
  //     });
  //     window.location.reload()
  //   }
  //   else{
  //     setTableData(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  //   }

   
  // },[rowsPerPage,page])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };

  const renderReport = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        // className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        {/* <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Report Details:</label>
            </div>
          </div>
        </Grid> */}
        <Grid item md={12} lg={12} xs={12} sm={10}>
          <div className={styles.formDiv}>
            <div
              //  className={styles.customeTable}
              className={styles.col2}
              style={{
                width: "100%",
                height: "100%"
              }}
            >
               <ReportTable columns={baseDefaultColumns} data={allData} height={HEIGHT} fileName={FILENAME}/>
              {/* <Table
                viewDisplay={viewDisplay}
                columns={baseDefaultColumns}
                defaultColumns={baseDefaultColumns}
                rowHeight={ROW_HEIGHT}
                rows={tableData}
                secondaryActions={[
                  {
                    name: "Export",
                    getFilteredData: true,
                    authOperation: "create-project",
                    shouldEnable: (tableArray) => tableArray,
                    actionFn: (filteredData) => {
                      // goTo(selected),
                      // handleExport(filteredData);
                      // ExportFile(filteredData)
                      downloadExcel(filteredData);
                    }
                  }
                ]}
                setAsnCount={setCount}
                isDataLoading={false}
                actionButtons
                //    onRowSelect={(e) => { console.log('onRowSelect call') }}
              />
               <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={allTableData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                
              /> */}
              
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >
        <CustomFormGroup
          header="SAP Data Transfer Report"
          body={renderOther()}
        />
        {loading ?
         <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
         <Truckloading />
         </div> : tableFlag && renderReport()}
      </div>
    </>
  );
}

ReportNoPO.propTypes = {
  redirectToProcessPage: PropTypes.func
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam))
});
ReportNoPO.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object
};
const App = connect(mapStateToProps, mapDispatchToProps)(ReportNoPO);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);